export default function ServiceAreaStatement() {
  return null;
}